const keys = {
  "zapierApi" : "https://hooks.zapier.com/hooks/catch/3783940/lsmr13/",
  "captchaKey": "6LeNAXQUAAAAACy7JDqhAANjnMIDIMMLSU0KM6ou"
}

export default keys;